<script>
  import { sendReaction, setReactionRateLimitError } from '../js/actions.js';
  import { REACTIONS } from '../js/l10n/en_US.js';

  export let token,
    source,
    eventId,
    position = 0;

  let reactions = [
      { reaction: 'smile', icon: '😀' },
      { reaction: 'love', icon: '😍' },
      { reaction: 'shocked', icon: '🤯' },
      { reaction: 'sad', icon: '😢' },
      { reaction: 'angry', icon: '😡' },
    ],
    sentReactions = [], // tracks messages in rate limit window
    rateLimitPerMinute = 5,
    allowSend = true;

  function send(reaction) {
    let t = new Date(),
      delay = 0;
    sentReactions.push(t);

    if (sentReactions.length > rateLimitPerMinute) {
      let diff = 60000 - (t.getTime() - sentReactions[0].getTime());
      delay = Math.max(diff, 0);
      allowSend = delay == 0;

      !allowSend && setReactionRateLimitError();
      setTimeout(function() {
        sentReactions = [];
        allowSend = true;
      }, delay);
    }

    allowSend && sendReaction(token, source, eventId, reaction, position);
  }
</script>

<style>
  .reaction-controls {
    margin: 0.5em 1em;
  }
  button {
    border: none;
    background: none;
    padding: 2px;
    margin: 0 2px;
    border: none;
  }
  span {
    display: inline-block;
    padding: 2px;
    margin: 0 2px;
    font-size: 10px;
    color: #666;
  }
  ::selection {
    border: none !important;
  }
  ::-moz-selection {
    border: none !important;
  }
</style>

<div class="reaction-controls">
  <span>{REACTIONS}</span>
  {#each reactions as reaction}
    <button on:click={() => send(reaction.reaction)}>{reaction.icon}</button>
  {/each}
</div>
